import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../shared/services/notification.service';
import { ForgotPasswordModel } from '../../auth-models';
import { AuthService } from '../../auth.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {

  get email() {
    return this.form.get("email");
  }

  /*
  // Moved to ngOnInit to avoid initialization errors.
  form = this.fb.group({
    email: ["", { validators: [Validators.required, Validators.email]}],
  });
  */
 form: any;

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      email: ["", { validators: [Validators.required, Validators.email]}],
    });
  }
  
  getErrorMessage() {
    return this.email.hasError("required")
      ? "You must enter a value"
      : this.email.hasError("email")
        ? "Not a valid email"
        : "";
  }

  onSubmit() {
    this.getErrorMessage();
    const pwReminderObj: ForgotPasswordModel = {
      email: this.email.value
    };
    this.authService
      .forgotPassword(pwReminderObj)
      .subscribe(
        (_) => {
          this.notificationService.success(
            "The link has been sent.  Please check your email to reset your password."
          );
        },
        () => {
          this.notificationService.error("Send forgotten password link failed!");
        }
      );
  }

}
